import { s as safeIsEqual } from './deepCopy-BPIPBkff.js';

function debounce(func, delay = 300, { maxWaitMs } = { maxWaitMs: void 0 }) {
  let timer;
  let maxWaitTimer;
  let lastArgs;
  return (...args) => {
    lastArgs = args;
    if (maxWaitMs && !maxWaitTimer) {
      maxWaitTimer = setTimeout(() => {
        clearTimeout(timer);
        clearTimeout(maxWaitTimer);
        func(...lastArgs);
      }, maxWaitMs);
    }
    clearTimeout(timer);
    timer = setTimeout(() => {
      clearTimeout(maxWaitTimer);
      func(...args);
    }, delay);
  };
}

function groupData ({
  data,
  getGroupKey,
  // getGroupKeySort, // to be implemented later, if needed
  initialGroupKeys = [],
  keyCompareFunction = safeIsEqual,
}) {
  if (!getGroupKey)
    return []

  const initialGroupedDataObj = initialGroupKeys.map(key => ({ key, data: [] }));

  return data?.reduce((arr, item) => {
    // if getGroupedKey returns array, then data will be grouped into BOTH keys
    const key = getGroupKey(item);
    const keysArray = Array.isArray(key) ? key : [key];
    keysArray.forEach((key) => {
      const keyIndex = arr.findIndex(item => keyCompareFunction(item.key, key));
      if (keyIndex === -1)
        arr.push({ key, data: [item] });
      else
        arr[keyIndex].data.push(item);
    });
    return arr
  }, initialGroupedDataObj)
}

export { debounce as d, groupData as g };
//# sourceMappingURL=groupData-Dl8C-s_B.js.map
